"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AblyTransport = exports.getChannelId = void 0;
const Ably = __importStar(require("ably"));
const crypto = __importStar(require("crypto"));
exports.getChannelId = (target) => {
    if (target.kind === 'USER') {
        const hash = crypto
            .createHash('sha256')
            .update(`USER:${target.userId}`)
            .digest('hex');
        return hash;
    }
    if (target.kind === 'END_CONSUMER') {
        const hash = crypto
            .createHash('sha256')
            .update(`END_CONSUMER:${target.userId}`)
            .digest('hex');
        return hash;
    }
    if (target.kind === 'STOREFRONT_SESSION') {
        const hash = crypto
            .createHash('sha256')
            .update(`STOREFRONT_SESSION:${target.sessionUUID}`)
            .digest('hex');
        return hash;
    }
    throw Error(`${JSON.stringify(target)} is not a valid target`);
};
exports.AblyTransport = (config) => {
    const realtime = new Ably.Realtime({
        key: config.apiKey,
    });
    const getChannel = (channelTarget) => {
        const channelId = exports.getChannelId(channelTarget);
        const channel = realtime.channels.get(channelId);
        const subscribe = (event, onMessage) => {
            const listener = (e) => onMessage(e.data);
            channel.subscribe(event, listener);
            const unsubscribe = () => channel.unsubscribe(event, listener);
            return { unsubscribe };
        };
        const publish = (message) => new Promise((resolve, reject) => {
            channel.publish(message.event, message, (error) => {
                if (error) {
                    reject(error);
                }
                else {
                    resolve(null);
                }
            });
        });
        const leave = () => new Promise((resolve, reject) => {
            channel.detach((error) => {
                if (error) {
                    reject(error);
                }
                else {
                    resolve(null);
                }
            });
        });
        const getInfo = () => {
            const { state, errorReason, params, name } = channel;
            return {
                state,
                errorReason,
                params,
                name,
            };
        };
        return {
            subscribe,
            publish,
            leave,
            getInfo,
        };
    };
    const disconnect = () => {
        realtime.close();
    };
    return { getChannel, disconnect };
};
